import { IFormContext }                from 'rewire-ui';
import DataMutations                   from '../graphql/Mutations';
import DataQueries                     from '../graphql/Queries';
import { getAdvancedFormAutoComplete } from '../ui/AdvancedAutoComplete';
import { getNameSearcher }             from '../utility/Searchers';
import mainPageModel                   from '../main-navigation/MainPageModel';
import DocumentDialogModel, {
  DocumentSchema
}                                      from './DocumentDialogModel';

const groupSchema = `
  ${DocumentSchema}
  area {
    id
    name
  }
`;

const areaSearcher = getNameSearcher('areas');

export class GroupDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'Group',
      (ids: string[]) => DataQueries.getGroupsByIds(groupSchema, ids),
      DataMutations.insertGroups,
      DataMutations.updateGroups,
      DataMutations.deleteGroups,
      'groups',
      () => mainPageModel.canAddGroups,
      () => mainPageModel.canEditGroups,
      () => mainPageModel.canDeleteGroups,
    );
  }

  protected otherFields(form: IFormContext) {
    return {
      area: getAdvancedFormAutoComplete(form, areaSearcher).label('Area').placeholder('select area').disabled(() => this.isAreaSearcherDisabled),
    };
  }

  private get isAreaSearcherDisabled(): boolean {
    return !this.isNew;
  }

  mapToSave(): ObjectType {
    const obj = super.mapToSave();
    if (this.isNew) {
      obj.position = 0;
      obj.areaId   = obj.area?.id;
      delete obj.area;
    } else {
      delete obj.area;
      this.form.field.area.disabled!(this.form.field.area);
    }
    return obj;
  }

  async load(id?: string, isModal: boolean = true) {
    await super.load(id, isModal);
    this.state.enable = true;
  }
}

const groupDialogModel = new GroupDialogModel();
export default groupDialogModel;
